import { createStore, applyMiddleware, combineReducers } from 'redux'
import { createBrowserHistory } from 'history'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './rootSaga'
import { createReduxHistoryContext } from 'redux-first-history';
import storage from 'redux-persist/lib/storage'
import { persistStore, persistReducer } from 'redux-persist'
import * as reducers from './domains';


const { createReduxHistory, routerMiddleware, routerReducer: rReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
    basename: process.env.PUBLIC_URL
});

export const routerReducer = rReducer;

export const rootReducer = combineReducers({
    router: routerReducer,
    ...reducers
})

const sagaMiddleware = createSagaMiddleware()
const middlewares = [routerMiddleware, sagaMiddleware]

const composeWithEnhancers = composeWithDevTools({
    trace: true,
    traceLimit: 25,
})

export type AppState = ReturnType<typeof rootReducer>

const persistConfig = {
    key: process.env.PUBLIC_URL + '/root',
    storage,
    blacklist: ['router', 'global', 'ext_app', 'resource', 'resourcegraph', 'explorer', 'filter']
}

const persistedReducer = persistReducer<AppState>(persistConfig, rootReducer)

export const store = createStore(
    persistedReducer,
    composeWithEnhancers(applyMiddleware(...middlewares))
)

export const history = createReduxHistory(store);

export const persistor = persistStore(store)
sagaMiddleware.run(rootSaga)
